import { ColumnData } from 'ui/tableHeader';

export const DISPLAY_WEBHOOK_JSON_ATTRIBUTES_MODAL_TEST_ID = 'display-webhook-json-attribute-modal';
export const DISPLAY_WEBHOOK_JSON_ATTRIBUTES_BUTTON_TEST_ID =
  'display-webhook-json-attribute-button';
export const DISPLAY_WEBHOOK_JSON_ATTRIBUTES_DOCS_LINK_TEST_ID =
  'display-webhook-json-attribute-docs-link';

export enum WebhookJSONKey {
  MetricAlertName = 'metricAlertName',
  MetricAlertText = 'metricAlertText',
  CampaignName = 'campaignName',
  CampaignId = 'campaignId',
  CampaignState = 'campaignState',
  CampaignType = 'campaignType',
  CampaignMedium = 'campaignMedium',
  CampaignAnalyticsLink = 'campaignAnalyticsLink',
  TemplateId = 'templateId',
}

export const JSON_ATTRIBUTE_ROWS = [
  {
    id: WebhookJSONKey.MetricAlertName,
    jsonKey: WebhookJSONKey.MetricAlertName,
    description: 'The name of the alert and metric triggered',
    example: 'TotalEmailSends',
  },
  {
    id: WebhookJSONKey.MetricAlertText,
    jsonKey: WebhookJSONKey.MetricAlertText,
    description: 'A description of the alert that’s triggered',
    example: 'TotalEmailSend less than 10',
  },
  {
    id: WebhookJSONKey.CampaignName,
    jsonKey: WebhookJSONKey.CampaignName,
    description: 'The name of the alerted campaign',
    example: 'Monthly Newsletter',
  },
  {
    id: WebhookJSONKey.CampaignId,
    jsonKey: WebhookJSONKey.CampaignId,
    description: 'The ID of the alerted campaign',
    example: '156848',
  },
  {
    id: WebhookJSONKey.CampaignState,
    jsonKey: WebhookJSONKey.CampaignState,
    description: 'The state of the alerted campaign when alert triggered',
    example: 'Running',
  },
  {
    id: WebhookJSONKey.CampaignType,
    jsonKey: WebhookJSONKey.CampaignType,
    description: 'The type of the alerted campaign (Triggered or Blast)',
    example: 'Blast',
  },
  {
    id: WebhookJSONKey.CampaignMedium,
    jsonKey: WebhookJSONKey.CampaignMedium,
    description: 'The channel of the alerted campaign',
    example: 'Email',
  },
  {
    id: WebhookJSONKey.CampaignAnalyticsLink,
    jsonKey: WebhookJSONKey.CampaignAnalyticsLink,
    description: 'A link to the campaign analytics of the alerted campaign',
    example: 'https://app.iterable.com/analytics...',
  },
  {
    id: WebhookJSONKey.TemplateId,
    jsonKey: WebhookJSONKey.TemplateId,
    description: 'The ID of the template used within the alerted campaign',
    example: '15687',
  },
];

export const JSON_ATTRIBUTE_HEADER_COLUMNS: ColumnData[] = [
  {
    align: 'flex-start',
    name: 'JSON Key',
    value: 'jsonKey',
    sortable: false,
  },
  {
    align: 'flex-start',
    name: 'Description',
    value: 'description',
    sortable: false,
  },
  {
    align: 'flex-start',
    name: 'Example',
    value: 'example',
    sortable: false,
  },
];
